document.addEventListener('DOMContentLoaded', function() {
  // Function to filter, sort, and update the accordion state
  function filterAndSortFAQs() {
    // Step 1: Get the selected category's data-category value
    var selectedCategory = document.querySelector('.faq_category.selected');
    if (!selectedCategory) return;
    var selectedCategoryValue = selectedCategory.getAttribute('data-category');

    // Step 2: Select all FAQ items
    var faqItems = Array.from(document.querySelectorAll('.accordion_item.faq_question'));

    // Step 3: Filter FAQ items that match the selected category
    var filteredItems = faqItems.filter(function(item) {
      return item.getAttribute('data-blog') === selectedCategoryValue;
    });

    // Step 4: Sort items with 'hits:' tag by the value in descending order
    filteredItems.sort(function(a, b) {
      // Extract 'hits:' value from both items
      var hitsA = a.className.match(/hits:(\d+)/) ? parseInt(a.className.match(/hits:(\d+)/)[1], 10) : 0;
      var hitsB = b.className.match(/hits:(\d+)/) ? parseInt(b.className.match(/hits:(\d+)/)[1], 10) : 0;

      // Sort by hits in descending order
      return hitsB - hitsA;
    });

    // Step 5: Get the parent container to reorder the elements
    var parent = filteredItems[0] ? filteredItems[0].parentElement : null;

    // Step 6: Append sorted items back into the parent container
    if (parent) {
      // Hide all FAQ items
      faqItems.forEach(function(item) {
        item.style.display = 'none';
      });

      // Show the filtered and sorted FAQ items
      filteredItems.forEach(function(item) {
        item.style.display = 'block';
        parent.appendChild(item); // Reorder items in the DOM
      });

      // Step 7: Close all opened accordions and update the 'collapsed' class on the links
      var allAccordions = document.querySelectorAll('.collapse');
      allAccordions.forEach(function(accordion) {
        // Close the accordion
        accordion.classList.remove('show');
        accordion.setAttribute('aria-expanded', 'false');
        
        // Find the link and add the 'collapsed' class
        var link = accordion.previousElementSibling;
        if (link && link.classList.contains('faq_question_title')) {
          link.classList.add('collapsed');
        }
      });

      // Step 8: Open the first accordion in the filtered items
      var firstAccordion = filteredItems[0].querySelector('.collapse');
      if (firstAccordion) {
        firstAccordion.classList.add('show');
        firstAccordion.setAttribute('aria-expanded', 'true');
        
        // Find the link and remove the 'collapsed' class
        var firstLink = firstAccordion.previousElementSibling;
        if (firstLink && firstLink.classList.contains('faq_question_title')) {
          firstLink.classList.remove('collapsed');
        }
      }
    }
  }

  // Call filterAndSortFAQs when the page is loaded
  filterAndSortFAQs();

  // Add event listeners to each category to trigger re-filtering and re-sorting when a category is selected
  var categories = document.querySelectorAll('.faq_category');
  categories.forEach(function(category) {
    category.addEventListener('click', function() {
      // Remove the "selected" class from the previously selected category
      document.querySelector('.faq_category.selected').classList.remove('selected');
      
      // Add the "selected" class to the clicked category
      category.classList.add('selected');

      // Re-filter and re-sort FAQs
      filterAndSortFAQs();
    });
  });
});
